import React, {Suspense} from "react";
import ueberunsStyle from "../styles/UeberUns.module.scss";
import {useTranslation, Trans} from "react-i18next";

function HeaderComponent()
{
	const {t} = useTranslation('translation');

    return  <div className="about" id="wrapper">
	<main>
	  <div className={ueberunsStyle.person} id="veeser">
		  <figure><img src="images/Klaus_aktuell.jpg" alt="Nikolaus Veeser" id="klaus"/>
			  <figcaption>Nikolaus Veeser</figcaption>
		  </figure>
		  <p>{t('about.bio.nv')}</p>
	  </div>
	  <div className={ueberunsStyle.person}>
		  <figure><img src="images/HildePols.png" alt="Hilde Pols"/>
			  <figcaption>Hilde Pols</figcaption>
		  </figure>
		  <p>{t('about.bio.hp')}</p>
	  </div>
	  <div className={ueberunsStyle.person}>
		  <figure><img src="images/rombach.png" alt="Markus Rombach"/>
			  <figcaption>Markus Rombach</figcaption>
		  </figure>
		  <Trans i18nKey="about.bio.mr" components={{ ul: <ul />, li: <li />, p: <p />, em: <i />, bold: <strong /> }}/>
	  </div>
  </main>
  <aside>
	<Trans i18nKey="about.aside" components={<p />}/>
  </aside>
	  </div>
}

function UeberUns() {
  return (
	<Suspense fallback="loading">
	<div className="App">
		<HeaderComponent/>
	</div>
</Suspense>
  );
}

export default UeberUns;